import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/formbuilder`;
export const createFormBuilder = async (formBuilder) => {
  return await axios.post(`${httpUrl}/create`, formBuilder).then((response) => response);
};

export const getFormsBuilder = async () => {
  return await axios.get(`${httpUrl}/list`).then((response) => response);
};

export const getFormBuilderById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deleteFormBuilder = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
